import { createCdnLinkApi, createPresignedUrlApi } from '@apis/system';
import { Toast } from '@components/_atoms/Toast';
import { AxiosError } from 'axios';
import { CreateCdnUrlPayload } from 'models/Supplement';
import { SystemPostPresignedUrlError, SystemPostPresignedUrlPayload } from 'models/swagger/data-contracts';
import { useMutation } from 'react-query';

/**
 *  Presigned URL 생성 Fetch
 *  @function useCreatePresignedUrlFetch
 */
export const useCreatePresignedUrlFetch = () => {
  const { mutate: createPresignedUrlMutate, isLoading: createPresignedUrlFetchIsLoading } = useMutation(
    ['createPresignedUrl'],
    ({ target, ext }: SystemPostPresignedUrlPayload) => createPresignedUrlApi({ target, ext }),
    {
      onError: (err: AxiosError<SystemPostPresignedUrlError>) => {
        if (err.response?.data?.message) {
          Toast.error(err.response.data.message.text);
        }
      },
    },
  );

  return {
    createPresignedUrlMutate,
    createPresignedUrlFetchIsLoading,
  };
};

/**
 *  CDN URL 생성 Fetch
 *  @function useCreateCdnUrlFetch
 */
export const useCreateCdnUrlFetch = () => {
  const { mutate: createCdnUrlMutate, isLoading: createCdnUrlFetchIsLoading } = useMutation(
    ['createCdnUrl'],
    ({ url, file }: CreateCdnUrlPayload) => createCdnLinkApi({ url, file }),
    {
      onError: (err: AxiosError<SystemPostPresignedUrlError>) => {
        if (err.response?.data?.message) {
          Toast.error(err.response.data.message.text);
        }
      },
    },
  );

  return {
    createCdnUrlMutate,
    createCdnUrlFetchIsLoading,
  };
};
